import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SRMark } from "./SRMark";

const AUTH_IMAGE =
  "https://images.unsplash.com/photo-1585821569995-86966667ca62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const AuthLayout = ({ title, subtitle, children, testId, eyebrow }) => {
  return (
    <div className="min-h-screen w-full lg:grid lg:grid-cols-2 bg-background" data-testid={testId}>
      {/* Form side */}
      <div className="flex items-center justify-center px-6 py-12 sm:px-12 animate-fadein">
        <div className="w-full max-w-md">
          <div className="mb-8 flex items-center justify-between gap-2.5">
            <Link to="/" className="flex items-center gap-2.5" data-testid="auth-home-logo">
              <SRMark size="lg" />
              <span className="font-heading text-xl font-semibold tracking-tight text-slate-900">
                SimplyRefer
              </span>
            </Link>
            <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-primary" data-testid="auth-back-home-link">
              <ArrowLeft className="h-4 w-4" /> Home
            </Link>
          </div>

          {eyebrow && (
            <span className="mb-3 inline-block rounded-md bg-secondary px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-secondary-foreground">
              {eyebrow}
            </span>
          )}
          <h1 className="font-heading text-3xl font-semibold tracking-tight text-slate-900">
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}

          <div className="mt-8">{children}</div>

          <p className="mt-8 text-center text-xs text-slate-400" data-testid="support-contact">
            Questions? Contact us at{" "}
            <a href="mailto:hello@simplyrefer.com.au" className="font-medium text-primary hover:underline">
              hello@simplyrefer.com.au
            </a>
          </p>
          <p className="mt-2 text-center text-xs text-slate-400">
            <a href="/terms" className="hover:text-primary hover:underline" data-testid="terms-link">Terms of Service</a>
            <span className="mx-2">·</span>
            <a href="/privacy" className="hover:text-primary hover:underline" data-testid="privacy-link">Privacy Policy</a>
          </p>
        </div>
      </div>

      {/* Image side */}
      <div className="relative hidden lg:block">
        <img
          src={AUTH_IMAGE}
          alt="Calm psychologist consulting room with two armchairs"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/45" />
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <p className="font-heading text-2xl font-medium leading-snug text-white drop-shadow">
            Making connections between clinicians beautifully simple.
          </p>
        </div>
      </div>
    </div>
  );
};
